import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import socketService from "./services/SocketService";
import ToastProvider from "./components/common/ToastProvider";
import { appRoutes } from "./config/routes";

function App() {
  useEffect(() => {
    socketService.connectToChat();
    return () => {
      socketService.disconnect();
    };
  }, []);

  return (
    <>
      <Routes>
        {appRoutes.map((route) =>
          route.children ? (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
            >
              {route.children.map((child) => (
                <Route
                  key={child.path ?? "index"}
                  path={child.index ? undefined : child.path}
                  index={child.index}
                  element={child.element}
                />
              ))}
            </Route>
          ) : (
            <Route key={route.path} path={route.path} element={route.element} />
          )
        )}
      </Routes>
      <ToastProvider />
    </>
  );
}

export default App;
